import Vue from 'vue'
import Scroll from '@/directives/scroll'
import CMDEnter from '@/directives/cmdenter'

Vue.directive(Scroll.name, Scroll)
Vue.directive(CMDEnter.name, CMDEnter)
